import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { LastEvaluationEventQuery, LastEvaluationEventQueryVariables } from '@/shared/api';
import LAST_EVALUATION_EVENT_QUERY from '../queries/lastEvaluationEvent';

/**
 * Loads a study together with its most recent evaluation event. Runs LAST_EVALUATION_EVENT_QUERY and throws the first GraphQL error message when the study field is nil.
 *
 * @param id - Identifier of the study to load.
 * @returns The study record with its last evaluation event.
 */
const fetchLastEvaluationEvent = async (id: any) => {
  const client = createClient();
  const result = await client.query<LastEvaluationEventQuery, LastEvaluationEventQueryVariables>({
    query: LAST_EVALUATION_EVENT_QUERY,
    variables: {
      id,
    },
  });
  const { data, errors } = result;
  const { study } = data;
  if (_.isNil(study) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return study;
};

export default fetchLastEvaluationEvent;
